/** Reset the document scroll position — use on route changes so new pages start at the top. */
export function resetWindowScroll(): void {
  if (typeof window === 'undefined') return
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}
